import { render, staticRenderFns } from "./RepresentativeActionDelete.vue?vue&type=template&id=8bea7c10&"
import script from "./RepresentativeActionDelete.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports